import React,{ useEffect  } from 'react';
import MainLayout from './components/MainLayout';
import './App.css'; 

function App() {
  useEffect(() => {
    window.addEventListener('popstate', (e) => {
      window.history.go(1);
    });
  }, []);
  return (
    <div className="App">
      <h2>App</h2>      
    </div>
  );
}

export default App;
